import script from "./AIconLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AIconLink.vue?vue&type=script&setup=true&lang=js"

import "./AIconLink.vue?vue&type=style&index=0&id=15829bcc&lang=scss"

const __exports__ = script;

export default __exports__